class Carousel {
    constructor(el) {
        if (el._carouselLoaded) return;

        this.scope = el;

        // Elements
        this.slides = this.scope.querySelector("[data-slides]");
        this.prevBtn = this.scope.querySelector("[data-prev]");
        this.nextBtn = this.scope.querySelector("[data-next]");
        this.navContainer = this.scope.querySelector("[data-nav]");
        this.navTemplate = this.navContainer?.firstElementChild?.cloneNode(true) ?? null;
        this.controlsBar = this.scope.querySelector("[data-controls]");
        this.autoPlay = this.scope.hasAttribute("data-autoplay");
        this.pausePlayControls = this.scope.querySelectorAll("[data-play-pause]");
        this.loop = this.scope.hasAttribute("data-loop");

        if (this.scope.hasAttribute("data-count")) {
            const countAttribute = this.scope.getAttribute("data-count");
            this.count = JSON.parse(countAttribute);
        } else {
            this.count = [1, 1, 1, 1];
        }
        if (this.scope.hasAttribute("data-speed")) {
            this.speed = this.scope.getAttribute("data-speed");
        }else{
            this.speed = 300;
        }

        this.slider = null;

        this.init();
    }
    
    getDynamicGutters() {
        const styles = getComputedStyle(this.slides);
        
        const mobile = parseInt(styles.getPropertyValue("--mob-gutter")) || 0;
        const desktop = parseInt(styles.getPropertyValue("--desktop-gutter")) || mobile;
        
        return { mobile, desktop };
    }


    init() {
        if (!this.slides) return;

        this.slider = tns({
            container: this.slides,
            autoplay: true,
            controls: false,
            nav: false,
            mouseDrag: true,
            loop: this.loop,
            speed: this.speed,
            gutter: this.getDynamicGutters().mobile,
            items: this.count[0],
            "responsive": {
                "768": {
                    items: this.count[1],
                    slideBy: 1,
                    gutter: this.getDynamicGutters().desktop,
                },
                "1024": {
                    items: this.count[2],
                    slideBy: 1
                },
                "1280": {
                    items: this.count[3],
                    slideBy: 1
                }
            }
            
        });
        setTimeout(()=>{
            if(!this.autoPlay){
                this.slider.pause();
            }
            this.scope.querySelectorAll('.tns-outer > button[data-action]').forEach(button => button.remove());
        }, 60)


        const overflowWrapper = this.scope.querySelector(".tns-ovh");
        overflowWrapper?.addEventListener("scroll", () => {
            overflowWrapper.scrollLeft = 0;
        });

    
        if (overflowWrapper && "IntersectionObserver" in window) {
            const slideVisibility = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    entry.target.inert = !entry.isIntersecting;
                });
            }, { root: overflowWrapper, threshold: 0 });

            this.scope.querySelectorAll(".tns-item").forEach(item => slideVisibility.observe(item));
        }

        this.bindControls();
        this.pausePlayControls.length > 0 && this.bindPlayPause();
        this.buildNav();
        this.updateNavState();

        this.slider.events.on("indexChanged", () => this.updateNavState());


        this.slider.events.on("newBreakpointStart", () => {
            setTimeout(() => {
                this.buildNav();
                this.updateNavState();
            }, 0);
        });
        
        this.scope._carouselLoaded = true;


        window.addEventListener("resize", () => {
            clearTimeout(this._resizeTimer);
            this._resizeTimer = setTimeout(() => {
                this.buildNav();
                this.updateNavState();
            }, 150);
        });


    }

    bindControls() {
        if (this.prevBtn) {
            this.prevBtn.addEventListener("click", () => {
                this.slider.goTo("prev");
            });
        }

        if (this.nextBtn) {
            this.nextBtn.addEventListener("click", () => {
                this.slider.goTo("next");
            });
        }
    }

    bindPlayPause(){
        this.pausePlayControls.forEach(pauseButton =>{
          pauseButton.addEventListener("click", ()=> {
              if(pauseButton.dataset.action === "stop"){
                  this.slider.pause();
                  this.updatePlayPause(true);
              }else{
                  this.slider.play();
                  this.updatePlayPause();
              }
            })
        })
    }
    
    updatePlayPause(paused){
        this.pausePlayControls.forEach(pauseButton =>{
            if(paused){
                pauseButton.dataset.action = "play"
                pauseButton.ariaLabel = "Play slides";
            }else{
                pauseButton.dataset.action = "stop";
                pauseButton.ariaLabel = "Pause slides";
            }
            pauseButton.querySelectorAll("svg").forEach(svg => {
                svg.classList.toggle("hidden");
            })
        })
    }

    buildNav() {
        if (!this.navContainer || !this.navTemplate) return;

        const info = this.slider.getInfo();
        const totalSlides = info.slideCount;
        const slidesInView = info.items;

        let navCount = totalSlides - slidesInView + 1;

        if (navCount < 1) navCount = 1;

        this.navCount = navCount;

        const singlePage = navCount <= 1;

        if (this.controlsBar) this.controlsBar.hidden = singlePage;

        this.navContainer.innerHTML = "";

        if (singlePage) return;

        for (let i = 0; i < navCount; i++) {
            const btn = this.navTemplate.cloneNode(true);
            btn.addEventListener("click", () => this.slider.goTo(i));
            this.navContainer.appendChild(btn);
        }
    }



    updateNavState() {
        if (!this.navContainer) return;

        const info = this.slider.getInfo();
        const navCount = this.navCount || 1;
        const activeNavIndex = Math.min(info.displayIndex - 1, navCount - 1);

        [...this.navContainer.children].forEach((btn, idx) => {
            const dots = btn.querySelectorAll("span");
            const active = idx === activeNavIndex;
            
            btn.classList.toggle("active", active);
        });
        if (this.prevBtn) {
            this.prevBtn.disabled = !this.loop && activeNavIndex === 0;
        }

        if (this.nextBtn) {
            this.nextBtn.disabled = !this.loop && activeNavIndex >= (info.slideCount - info.items);
        }   
        
    }


}

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-carousel]").forEach(el => new Carousel(el));
});

if ("navigation" in window && typeof window.navigation.addEventListener === "function") {
    window.navigation.addEventListener("navigate", () => {
        setTimeout(() => {
            document.querySelectorAll("[data-carousel]").forEach(el => {
                new Carousel(el);
            });
        }, 60);
    });
}